/**
 * Concurrent callers for the same key share ONE in-flight promise (RD-PERF-004).
 * Nothing is cached after it settles, so freshness is unchanged: the next call
 * after settle starts a new run. `invalidate()` forgets the in-flight entries so a
 * caller that just WROTE never joins a read that started before the write.
 */
const registry = new Set();
/** Sign-out: forget EVERY shared in-flight read so the next user never joins the previous user's. */
export function invalidateAllSharedInFlights() {
  registry.forEach((inst) => inst.invalidate());
}

export function createSharedInFlight({ maxAgeMs = 15000 } = {}) {
  const flights = new Map();
  const instance = {
    share(key, run) {
      const existing = flights.get(key);
      // A read older than maxAgeMs is treated as hung (iOS-PWA backgrounded fetch): start fresh.
      if (existing && Date.now() - existing.startedAt <= maxAgeMs) return existing.promise;
      const p = Promise.resolve().then(run).finally(() => {
        if (flights.get(key)?.promise === p) flights.delete(key);
      });
      flights.set(key, { promise: p, startedAt: Date.now() });
      return p;
    },
    invalidate() { flights.clear(); },
  };
  registry.add(instance);
  return instance;
}
